import { default as MyApp } from './src/App';

export default function App() { return MyApp() };
